import React, { useState } from 'react';
import { MultiConsentContext } from '.';
export const MultiConsentProvider = ({ children, consents, onComplete, }) => {
    const [asyncStatus, setAsyncStatus] = useState('None');
    const [activeConsentIndex, setActiveConsentIndex] = useState(0);
    const [focusIndex, setFocusIndex] = useState(0);
    const [successByIndex, setSuccessByIndex] = useState({});
    const showNextConsent = () => {
        if (activeConsentIndex < consents.length - 1) {
            setActiveConsentIndex(activeConsentIndex + 1);
            setFocusIndex(activeConsentIndex + 1);
            const newSuccessByIndex = Object.assign(Object.assign({}, successByIndex), { [activeConsentIndex]: true });
            setSuccessByIndex(newSuccessByIndex);
        }
        else {
            onComplete();
        }
    };
    const initialValue = {
        activeConsentIndex,
        setActiveConsentIndex,
        asyncStatus,
        setAsyncStatus,
        showNextConsent,
        focusIndex,
        successByIndex,
    };
    return (React.createElement(MultiConsentContext.Provider, { value: initialValue }, children));
};
//# sourceMappingURL=MultiConsentProvider.js.map